import React, { useEffect, useMemo, useState } from "react";
import classes from "./Section3.module.css";
import { googleReviews as testimonials } from "../../data/testimonials";

export default function Section3() {
  const slides = useMemo(() => {
    if (testimonials.length === 0) {
      return [];
    }

    return [
      testimonials[testimonials.length - 1],
      ...testimonials,
      testimonials[0],
    ];
  }, []);

  const [currentIndex, setCurrentIndex] = useState(1);
  const [enableTransition, setEnableTransition] = useState(true);

  useEffect(() => {
    if (testimonials.length <= 1) {
      return undefined;
    }

    const slider = setInterval(() => {
      setCurrentIndex((prev) => prev + 1);
      setEnableTransition(true);
    }, 5000);

    return () => clearInterval(slider);
  }, []);

  const handleTransitionEnd = () => {
    if (slides.length === 0) {
      return;
    }

    if (currentIndex === slides.length - 1) {
      setEnableTransition(false);
      setCurrentIndex(1);
    }

    if (currentIndex === 0) {
      setEnableTransition(false);
      setCurrentIndex(testimonials.length);
    }
  };

  useEffect(() => {
    if (!enableTransition) {
      const id = requestAnimationFrame(() => {
        setEnableTransition(true);
      });

      return () => cancelAnimationFrame(id);
    }

    return undefined;
  }, [enableTransition]);

  const handleDotClick = (index) => {
    setEnableTransition(true);
    setCurrentIndex(index + 1);
  };

  const activeDot =
    currentIndex === 0
      ? testimonials.length - 1
      : currentIndex === slides.length - 1
        ? 0
        : currentIndex - 1;

  return (
    <section className={classes.section3Wrapper}>
      <div className={classes.section3Container}>
        <h2 className={classes.section3Heading}>Client Testimonials</h2>

        <div className={classes.section3Slider}>
          <div
            className={classes.section3Track}
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
              transition: enableTransition
                ? "transform 0.8s ease-in-out"
                : "none",
            }}
            onTransitionEnd={handleTransitionEnd}
          >
            {slides.map((item, index) => (
              <div className={classes.section3Slide} key={index}>
                <p className={classes.section3Review}>"{item.review}"</p>
                <h3 className={classes.section3Name}>{item.name}</h3>
              </div>
            ))}
          </div>

          <div className={classes.section3Dots}>
            {testimonials.map((_, index) => (
              <button
                key={index}
                type="button"
                aria-label={`Go to testimonial ${index + 1}`}
                className={`${classes.section3Dot} ${
                  activeDot === index ? classes.section3DotActive : ""
                }`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
